import React from 'react';
import './Experience.css';
import portfolioData from '../data/portfolio.json';

const Experience = () => {
  const { experience } = portfolioData;

  return (
    <section id="experience" className="experience">
      <h2>Professional Experience</h2>
      <div className="timeline">
        {experience.map((job, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="job-header">
                <h3 className="job-title">{job.title}</h3>
                <span className="job-period">{job.period}</span>
              </div>
              <h4 className="job-company">{job.company}</h4>
              <ul className="responsibilities">
                {job.responsibilities.map((responsibility, idx) => (
                  <li key={idx}>{responsibility}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
